import type { EmblaCarouselType } from "embla-carousel";

export default function DragFreeSnap() {
  let emblaApi: EmblaCarouselType;

  function onPointerUp(): void {
    const engine = emblaApi.internalEngine();

    const momentumTarget = engine.target.get();
    const { scrollSnaps } = engine;

    // Find the snap point closest to where momentum is heading.
    let closestIndex = 0;
    let minDist = Infinity;
    for (let i = 0; i < scrollSnaps.length; i++) {
      const dist = Math.abs(scrollSnaps[i] - momentumTarget);
      if (dist < minDist) {
        minDist = dist;
        closestIndex = i;
      }
    }

    // Redirect the running animation directly to the snap position.
    engine.target.set(scrollSnaps[closestIndex]);

    // Sync Embla's internal index
    const prevIndex = engine.index.get();
    if (closestIndex !== prevIndex) {
      engine.indexPrevious.set(prevIndex);
      engine.index.set(closestIndex);
      emblaApi.emit("select");
    }
  }

  return {
    name: "dragFreeSnap",
    options: {},
    init(embla: EmblaCarouselType): void {
      emblaApi = embla;
      emblaApi.on("pointerUp", onPointerUp);
    },
    destroy(): void {
      emblaApi?.off("pointerUp", onPointerUp);
    },
  };
}
